// The Moments and Kudos sub-pages collapsed into the Community page. Keep
// bookmarks and notification deep links alive: land on the wall with the
// matching filter, carry ?kudos=<id> / ?moment=<id> across, and send the
// kudos page's own ?filter=received|sent views to the You tab, which is
// that personal view now (kudos-received notifications deep-link here).

import { Navigate, useLocation } from "react-router-dom";

export function LegacyCommunityRedirect({ filter }: { filter: "moments" | "kudos" }) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const legacyTab = params.get("filter");
  if (filter === "kudos" && (legacyTab === "received" || legacyTab === "sent")) {
    params.delete("filter");
    params.set("tab", "you");
  } else {
    params.set("filter", filter);
  }
  return <Navigate to={{ pathname: "/community", search: `?${params.toString()}` }} replace />;
}
